import { Details, DetailsTitle } from './Details/Details'
import { Initializing, InitializingTitle } from './Initializing/Initializing'
import { Payment } from './Payment/Payment'
import {
    CustomerShipping,
    CustomerShippingTitle,
} from './Shipping/Customer/CustomerShipping'
import {
    OrderShipping,
    OrderShippingTitle,
} from './Shipping/Order/OrderShipping'

const Checkout = {
    Initializing: {
        Title: () => <InitializingTitle />,
        View: () => <Initializing />,
    },
    Shipping: {
        Customer: {
            Title: () => <CustomerShippingTitle />,
            View: () => <CustomerShipping />,
        },
        Order: {
            Title: () => <OrderShippingTitle />,
            View: () => <OrderShipping />,
        },
    },
    Details: {
        Title: () => <DetailsTitle />,
        View: () => <Details />,
    },
    Payment: {
        Initializing: {
            Title: () => <Payment.Initializing.Title />,
            View: () => <Payment.Initializing.View />,
        },
        PaymentForm: {
            Title: () => <Payment.PaymentForm.Title />,
            View: () => <Payment.PaymentForm.View />,
        },
        Confirmation: {
            Title: () => <Payment.Confirmation.Title />,
            View: () => <Payment.Confirmation.View />,
        },
    },
}

export default Checkout
